// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2fb0e4ec","977":"f25ffb4e"}[chunkId] + ".chunk.js";
};